export default __webpack_public_path__ + "static/media/permeable-blog-9.6efcec00.jpg";